var babelHelpers = require('./babel-helpers.js');
/**
 * MUI React divider module
 * @module react/divider
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = babelHelpers.interopRequireDefault(_react);

/**
 * Divider constructor
 * @class
 */
var Divider = function (_React$Component) {
  babelHelpers.inherits(Divider, _React$Component);

  function Divider() {
    babelHelpers.classCallCheck(this, Divider);
    return babelHelpers.possibleConstructorReturn(this, (Divider.__proto__ || Object.getPrototypeOf(Divider)).apply(this, arguments));
  }

  babelHelpers.createClass(Divider, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          reactProps = babelHelpers.objectWithoutProperties(_props, ['children', 'className']);


      return _react2.default.createElement('div', babelHelpers.extends({}, reactProps, {
        className: 'mui-divider ' + className
      }));
    }
  }]);
  return Divider;
}(_react2.default.Component);

/** Define module API */


Divider.defaultProps = {
  className: ''
};
exports.default = Divider;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/muicss/lib/react/divider.js
// module id = 1448
// module chunks = 0